import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { EquipmentProfileHeader } from "./-components/EquipmentProfileHeader";

export const Route = createFileRoute("/_staff/equipment/$id/_layout")({
  component: Layout,
});

function Layout() {
  return (
    <>
      <EquipmentProfileHeader />
      <Suspense>
        <Outlet />
      </Suspense>
    </>
  );
}
